/**
 * Created by Alex Aguilar on 7/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('statesFlightService', statesFlightService);

    statesFlightService.$inject = ['$http', 'CONFIG'];

    function statesFlightService($http, CONFIG){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/statesFlight',
            service = {
                getStatesFlight: getStatesFlight
            };

        return service;

        function getStatesFlight(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.statesFlights : [];
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

    }
})();
